import { v4 as uuid } from 'uuid';
import { crewLeadLabel } from '@s20/i18n';
import { BillingRate, BillingRateTypes } from '../billing/BillingRate';
import { Weekdays } from '../Common';

export const ScheduleTypes = [
    { id: 1, name: '5/8' },
    { id: 2, name: '4/10' },
];

export const ContractScheduleTypes = [
    { value: 1, label: '5/8' },
    { value: 2, label: '4/10' },
];

export const LinkedWorkOrders = [
    { value: 1, label: 'Yes' },
    { value: 2, label: 'No' },
];

export const WorkOrderNumberOptions = [
    { value: 1, label: 'Required' },
    { value: 2, label: 'Optional' },
    { value: 3, label: 'N/A' },
];

export const getWorkCardOptions = (tenantSettings) => [
    { value: 1, label: 'Required (All)' },
    { value: 4, label: `Required (${crewLeadLabel(tenantSettings)} Only)` },
    { value: 2, label: 'Optional' },
    { value: 3, label: 'N/A' },
];

// Relocated to the shared constants module; re-exported here for backward compatibility.
export { ContractUnionWorkTypes } from '@s20/common/constants/contractUnionWorkTypes';

export const WarningThresholdOptions = [
    { label: '30', value: 30 },
    { label: '60', value: 60 },
    { label: '90', value: 90 },
];

export class ContractChargeTypeBillingRate {
    contractId = null;

    chargeTypeId = null;

    chargeTypeName = '';

    billingRateId = uuid();

    billingRate = new BillingRate();

    rateType = BillingRateTypes.CHARGE_TYPE;
}

export class ContractChargeTypeGroupBillingRate {
    contractId = null;

    chargeTypeGroupId = null;

    chargeTypeName = '';

    billingRateId = uuid();

    billingRate = new BillingRate();

    rateType = BillingRateTypes.CHARGE_TYPE_GROUP;
}

export class ContractChargeTypeUSCountyGroupBillingRate extends ContractChargeTypeBillingRate {
    usCountyGroupId = null;
    usCountyGroup = null;
}
export class ContractChargeTypeJobTypeBillingRate extends ContractChargeTypeBillingRate {
    jobTypeId = null;
    jobTypeName = null;
}

export const ChargeTypeEligbility = {
    Required: 1,
    Optional: 2,
    DoNotUse: 3,
};

export const WorkOrderNumberTypes = {
    Required: 1,
    Optional: 2,
    DoNotUse: 3,
};

export const ChargeTypeEligibilities = [
    { name: 'Required', id: 1 },
    { name: 'Optional', id: 2 },
    { name: 'Do Not Use', id: 3 },
];

export const ContractStatus = [
    { id: 1, description: 'Active' },
    { id: 2, description: 'Inactive' },
    { id: 3, description: 'On Hold' },
];

export const _ContractStatuses = {
    Active: 1,
    Inactive: 2,
    OnHold: 3,
};

export const DayOfWeekSelect = Weekdays.map((d) => ({ value: d.id, label: d.name }));
export const DayOfMonthSelect = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
    11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27,
].map((d) => ({ label: `${d}`, value: d }));

export class Contract {
    id = null;

    companyId = '';

    companyName = '';

    operationsCenterCompanyId = '';

    operationsCenterCompanyName = '';
    contractUnionWorkTypeId = 1;
    isProjectContract = false;
    payrollIncentives = [];

    requiresProjectForQuickSale = false;

    number = '';

    description = '';

    contractStatusId = 1;

    contractStatusName = 'Active';

    contractScheduleTypeId = 1;

    billingHasSeparateContractSchedule = false;
    billingContractScheduleTypeId = 1;

    contractScheduleTypeName = '';

    requireEmployeeCheckins = false;

    allowSelfDispatch = false;

    enableNonFlaggingTimesheets = false;

    requireProjectCompletionReview = false;

    requireGLString = false;

    requireSelfDispatchTimesheetsClientSignature = false;

    allowLinkedWorkOrders = false;

    individualCharge = false;

    isUnionWork = false;

    workOrderTypeId = '';

    workOrderTypeName = '';

    useAlternativePayroll = false;

    timesheetResponsibilityTypeId = null;

    jobs = [];

    dispatchLocations = [];

    contractLocations = [];

    contractChargeTypes = [];

    contractChargeTypeGroups = [];

    contractNewChargeTypes = [];

    effectiveDate = new Date();

    expirationDate = null;

    warningThresholdInDays = 0;

    estimatedShiftLengthInHours = null;

    autoEscalatingRates = false;

    prevailingWage = false;
    requirePaySchedule = false;

    hasSundayDT = false;

    hasSundayRegularBilling = false;

    setupChargesRequired = false;

    certificationRequired = false;

    permitFeesApply = false;

    requireProjectInformation = false;

    createdFromId = null;

    estimateId = null;

    billingHasCustomBumpRules = false;

    requiresJobApproval = false;

    endCompanyId = null;

    billingCycleId = null;

    bumpRules = [];

    autoCalculateDriveTimeBilling = false;
    isQuickRentalContract = false;
    requireFullSSN = false;
}
